import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AssignmentViewer from '../components/AssignmentViewer';
import LoadingSpinner from '../components/LoadingSpinner';

const AssignmentViewPage = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const mode = searchParams.get('mode') || 'preview';
  const [assignment, setAssignment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setError('No assignment id provided.');
      setLoading(false);
      return;
    }
    setLoading(true);
    const token = localStorage.getItem('token');
    fetch(`/api/assignments/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch assignment');
        return res.json();
      })
      .then(data => {
        setAssignment(data.assignment);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <LoadingSpinner />;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return <AssignmentViewer assignment={assignment} mode={mode} interactive={true} />;
};

export default AssignmentViewPage; 